// Product Info Drawer functionality
document.addEventListener('DOMContentLoaded', () => {
  console.log('Drawer product info script loaded');
  
  // Wait a bit more for all elements to be ready
  setTimeout(() => {
    console.log('Checking for drawer triggers...');
    
    const drawerTriggers = document.querySelectorAll('[data-drawer-trigger="product-info"]');
    console.log('Product info drawer triggers found:', drawerTriggers.length);
    
    // Debug: let's see what info-links exist
    const infoLinks = document.querySelectorAll('.info-link');
    console.log('Info links found:', infoLinks.length);
    infoLinks.forEach((link, index) => {
      console.log(`Info link ${index}:`, link.textContent, 'data-drawer-trigger:', link.getAttribute('data-drawer-trigger'));
    });
    
    // Function to close all accordions
    function closeAllAccordions() {
      const accordionItems = document.querySelectorAll('.accordion-item');
      accordionItems.forEach(item => {
        item.classList.remove('is-open');
      });
      console.log('All accordions closed');
    }
    
    // Function to open specific accordion based on link text
    function openAccordionByText(linkText) {
      setTimeout(() => {
        const accordionHeaders = document.querySelectorAll('[data-accordion-toggle]');
        
        // Close all accordion items first
        closeAllAccordions();
        
        accordionHeaders.forEach(header => {
          const headerText = header.querySelector('span').textContent.trim();
          const accordionItem = header.closest('.accordion-item');
          
          // Open the matching accordion
          if (
            (linkText.includes('Shipping') && headerText.includes('Shipping')) ||
            (linkText.includes('Garment') && headerText.includes('Garment')) ||
            (linkText.includes('Material') && headerText.includes('Material'))
          ) {
            accordionItem.classList.add('is-open');
            console.log('Opened accordion:', headerText);
          }
        });
      }, 100); // Small delay to ensure drawer is open
    }
    
    // Listen for drawer close events to reset all accordions
    document.addEventListener('closeDrawer', () => {
      console.log('Drawer close event detected, resetting accordions');
      closeAllAccordions();
    });
    
    // Also listen for when drawer overlay is clicked (common close method)
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('drawer-overlay')) {
        console.log('Drawer overlay clicked, resetting accordions');
        closeAllAccordions();
      }
    });
    
    // Listen for drawer close button clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer-close]')) {
        console.log('Drawer close button clicked, resetting accordions');
        closeAllAccordions();
      }
    });
    
    // Convert our custom triggers to use the existing drawer system
    drawerTriggers.forEach(trigger => {
      console.log('Adding event listener to trigger:', trigger.textContent);
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const linkText = trigger.textContent.trim();
        console.log('Product info drawer trigger clicked:', linkText);
        
        // First close all accordions
        closeAllAccordions();
        
        // Dispatch custom event that the existing drawer system listens for
        document.dispatchEvent(new CustomEvent('openDrawer', {
          detail: {
            drawerId: 'product-info',
            position: 'right'
          }
        }));
        
        // Open the corresponding accordion
        openAccordionByText(linkText);
      });
    });

    // Also check if drawer exists in DOM
    const drawer = document.querySelector('[data-drawer-id="product-info"]');
    console.log('Product info drawer found in DOM:', !!drawer);
    if (drawer) {
      console.log('Drawer element:', drawer);
    }

    // Accordion functionality
    const accordionHeaders = document.querySelectorAll('[data-accordion-toggle]');
    console.log('Accordion headers found:', accordionHeaders.length);
    
    accordionHeaders.forEach(header => {
      header.addEventListener('click', () => {
        const accordionItem = header.closest('.accordion-item');
        const isOpen = accordionItem.classList.contains('is-open');
        
        // Close all accordion items
        closeAllAccordions();
        
        // Toggle current item (only open if it was closed)
        if (!isOpen) {
          accordionItem.classList.add('is-open');
        }
      });
    });
  }, 500); // Wait 500ms for DOM to be fully ready
});
